<!--
 * @Author: mzw
 * @Date: 2021-09-27 10:15:26
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-08-24 15:25:11
 * @Description: 订单列表
-->
<template>
  <div class="order_list">
    <!-- tab -->
    <div class="tabs">
      <div v-for="(item,index) in tabList"
           :key="index"
           :class="'order-tab-item '+( ((item.type&&item.code===dataForm[item.type]) || (isAllTab&&!item.type) ) ?'tab-item-active':'')"
           @click="changeStatusHandle(item)">
        {{item.value}}
      </div>
      <el-button type="primary" :loading="downloadLoading" @click="download" class="download" icon="el-icon-download">导出明细</el-button>
    </div>
    <!-- 查询条件 -->
    <el-form :inline="true" :model="dataForm" class="searchForm">
      <el-form-item :label="`${$t('order.orderNo')}：`">
        <el-input v-model="dataForm.searchItem" :placeholder="$t('orderlist.orderNoHolder')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList(1)">{{$t('common.query')}}</el-button>
        <el-button class="butt" @click="refreshData">{{$t('common.reset')}}</el-button>
      </el-form-item>
      <el-row style="float:right;">
        <el-form-item>
          <el-dropdown @command="handleOrderStatus" v-if="isAllTab && orderStatusList.length>0">
            <span class="el-dropdown-link">
              <i class="el-icon-tickets" style="margin-right:9px;"></i>{{orderStaCheck}}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in orderStatusList" :key="index" :command='item'  v-text="item.value"></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item style="margin-right:0;">
          <el-dropdown @command="handleTimeType">
            <span class="el-dropdown-link">
              <i class="el-icon-date" style="margin-right:9px;"></i>{{timeTypeCheck}}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in timeTypeList" :key="index" :command='item'  v-text="item.value"></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-row>

    </el-form>
    <!-- 商品列表 -->
    <div class="order-box" v-if="dataList.length>0">
      <table class="order-head">
        <tr>
          <th width="320px">商品信息</th>
          <th width="95px">数量</th>
          <th width="100px">单价</th>
          <th width="200px">总计</th>
          <th width="125px">订单状态</th>
          <th width="125px">操作</th>
        </tr>
      </table>
      <div class="order-list" v-for="(item,index) in dataList" :key="index">
        <div class="order-title">
          <span>{{$t('orderlist.orderNo')}}：<font @click="detailOrderHandle(item)">{{item.orderCode}}</font></span>
          <Copyable  class="code"  v-if="item.orderCode" :text="item.orderCode"/>
          <span >{{$t('orderlist.customerNo')}}：{{item.custOrderNo||'-'}}</span>
          <Copyable v-if="item.custOrderNo" :text="item.custOrderNo"/>
          <span class="time">{{item.createTime}}</span>
        </div>
        <productBox2 :productList='item.payOrderItemRefactoryVos' :orderJson='item' :showHeader='false'
          @detailOrderHandle='detailOrderHandle'
          @cancelOrderHandle='cancelOrderHandle'
          @refresh="getDataList"
          @goToPay='goToPay' />
      </div>
      <el-pagination  layout="prev, pager, next"
        :current-page="dataForm.page"
        :page-size="dataForm.limit"
        :total="total"
        @size-change="pageSizeChangeHandle"
        @current-change="getDataList">
      </el-pagination>
    </div>
    <div class="no_show_message" v-else style="margin-top: 80px;">
      <img src="@/assets/img/good/noGood.png" :alt="$t('orderlist.noOrders')">
      <div>{{$t('orderlist.noOrders')}}</div>
    </div>
  </div>
</template>
<script>
import exportFun from '@/utils/export.js'
import { formateDate } from '@/utils/formateDate'
import productBox2 from './components/productBox2'
import Copyable from '@/components/copyable.vue'
export default {
  data () {
    return {
      dataLoading: false,
      tabList: [
        { code: '', value: this.$t('orderlist.statusOpt1'), type: '' },
        { code: '20', value: this.$t('orderlist.statusOpt2'), type: 'payStatus' },
        { code: '22', value: this.$t('orderlist.statusOpt3'), type: 'payStatus' },
        { code: '80', value: this.$t('orderlist.statusOpt4'), type: 'orderStatus' },
        { code: '90', value: this.$t('orderlist.statusOpt5'), type: 'orderStatus' }
      ],
      timeTypeList: [
        { code: 0, value: this.$t('orderlist.timeOpt1') },
        { code: 1, value: this.$t('orderlist.timeOpt2') },
        { code: 2, value: this.$t('orderlist.timeOpt3') },
        { code: 3, value: this.$t('orderlist.timeOpt4') }
      ],
      timeTypeCheck: this.$t('orderlist.timeOpt'),
      orderStatusList: [
        { code: '', value: this.$t('orderlist.orderStatusOpt1'), type: '' },
        { code: '50', value: this.$t('orderlist.orderStatusOpt2'), type: 'orderStatus' },
        { code: '60', value: this.$t('orderlist.orderStatusOpt3'), type: 'orderStatus' },
        { code: '70', value: this.$t('orderlist.orderStatusOpt4'), type: 'orderStatus' }
      ],
      orderStaCheck: this.$t('orderlist.orderStatusOpt'),
      isAllTab: true, // tab是否点击全部

      dataForm: {
        searchItem: '', // 搜索词
        timeType: 0, // number 查询订单时间 (0==全部,1==3天,2==1个月,3==3个月)
        orderStatus: '', // string 订单状态
        payStatus: '', // string 支付类型
        page: 1,
        limit: 3
      },
      total: 0,
      dataList: [],
      downloadLoading: false
    }
  },
  components: { productBox2, Copyable },
  mounted () {
    this.getDataList()
    // this.getOrderStatus();
  },
  methods: {
    // 下载
    download () {
      if (this.downloadLoading) {
        return
      }
      this.downloadLoading = true
      const fileName = `宁东工业超市订单明细_${formateDate('yyyy-MM-dd hh:mm:ss', new Date().getTime())}.xls` // 下载的文件名
      exportFun({
        url: '/front/consumer/edge/export/my-order-list',
        name: fileName,
        params: {
          ...this.dataForm
        },
        haveMsg: false
      }).then((t) => {
        // 操作成功
        this.downloadLoading = false
        if (t) {
          this.$message.success(this.$t('message.downloadSuccess'))
        }
      })
    },
    // 获取列表数据
    getDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let dataForm = this.dataForm
      this.$http.post(`/front/oms/shopping/saleorder/v1/page-my-order`, dataForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.total - 0 || 0
          this.dataList = res.data.records || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    changeStatusHandle (item) {
      if (this.dataLoading) {
        return false
      }
      if (item.code && item.code === this.dataForm[item.type]) {
        return false
      }
      this.dataForm[item.type] = item.code
      this.isAllTab = false
      if (item.type === 'payStatus') {
        this.dataForm.orderStatus = ''
      } else if (item.type === 'orderStatus') {
        this.dataForm.payStatus = ''
      } else {
        this.dataForm.orderStatus = ''
        this.dataForm.payStatus = ''
        this.orderStaCheck = this.$t('orderlist.orderStatusOpt1')
        this.isAllTab = true
      }
      this.getDataList(1)
    },

    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(0)
    },
    // 查看详情
    detailOrderHandle (row, isToView) {
      const srcInfo = this.$router.resolve({
        name: 'orderDetail',
        params: {
          id: row.orderId,
          isToView
        }
      })
      window.open(srcInfo.href, '_blank')
    },
    // 取消订单
    cancelOrderHandle (row) {
      let _this = this
      this.$confirm(this.$t('message.isCancelOrder'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.dataLoading = true
        _this.$http.post(`/front/consumer/shopping/order/cancelOrderById/${row.orderId}`)
          .then(({ data: res }) => {
            _this.dataLoading = false
            if (res.code === 0) {
              _this.$message.success(this.$t('message.handleSuccess'))
              _this.getDataList(1)
            } else {
              return false
            }
          })
          .catch(() => {
            _this.dataLoading = false
          })
      })
    },
    // 去支付
    goToPay (row) {
      if (row.customerPaymentMethod === '2') {
        this.$router.push({
          name: 'enterpriseTransferPayment',
          query: {
            id: row.orderId,
            money: row.totalPay || ''
          }
        })
        return
      }
      this.$router.push({
        name: 'orderPay',
        query: {
          id: row.orderId,
          money: row.totalPay,
          virtualAccount: row.virtualAccount
        }
      })
    },
    handleTimeType (com) {
      this.dataForm.timeType = Number(com.code)
      this.timeTypeCheck = com.value
      this.getDataList(1)
    },
    handleOrderStatus (com) {
      this.dataForm.orderStatus = com.code
      this.orderStaCheck = com.value
      this.getDataList(1)
    },
    // getOrderStatus(){
    //   //所有订单状态list
    //   let orderList = window.SITE_CONFIG['dictList']['NEW_ORDER_STATUS'];
    //   orderList.unshift({code:'',value:'全部订单状态'});
    //   this.orderStatusList = orderList;
    // },
    refreshData () {
      let dataForm = {
        searchItem: '',
        timeType: 0,
        orderStatus: '',
        payStatus: '',
        page: 1,
        limit: 3
      }
      this.dataForm = {
        ...this.dataForm,
        ...dataForm
      }
      this.timeTypeCheck = this.$t('orderlist.timeOpt1')
      this.orderStaCheck = this.$t('orderlist.orderStatusOpt1')
      this.getDataList(1)
    }
  }
}
</script>
<style lang='scss' scoped>
.tabs{
  margin:0;
  position: relative;

  .download{
    position: absolute;
    right: 0;
    top: 0;
  }
  .order-tab-item {
    display: inline-block;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    padding: 0 25px 46px 25px;
    cursor: pointer;
  }
  .tab-item-active{
    border-bottom: 2px solid #1989FA;
  }
  border-bottom: 2px solid #E4E7ED;
}
.searchForm{
  margin: 16px 0;
  .el-form-item{
    margin:0 24px 0 0;
  }
  .el-dropdown{
    width: 164px;
    height: 40px;
    border: 1px solid #D8DCE6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
  }
}

.order-box{
  $backColor: #F9F9F9;
  $borderColor: #DCDFE6;
  .order-head{
    width: 100%;
    background-color: $backColor;
    border: 1px solid $borderColor;
    box-sizing: border-box;
    th{
      height: 40px;
      vertical-align: middle;
      border-right: 1px solid $borderColor;
      color: #303133;
      font-weight: normal;
      &:last-child{
        border-right: none;
      }
    }
  }
  .order-list{
    .order-title{
      width: 100%;
      line-height: 40px;
      margin-top: 15px;
      padding: 0 15px;
      background-color: $backColor;
      border: 1px solid $borderColor;
      border-bottom: none;
      font-size: 12px;
      overflow: hidden;
      .code{
        margin-right: 12px;
        cursor: pointer;
        font{
          color: #1D66A8;
        }
      }
      .time{
        float: right;
      }
    }
  }
}
</style>
